export default __webpack_public_path__ + "static/media/FSEmericWeb-Regular.5674a89a.woff2";